// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ef1945a4","453":"8b852e6c","455":"bec2e104","977":"3356c2e6"}[chunkId] + ".chunk.js";
};